// extracted by mini-css-extract-plugin
export default {"pageButton":"PageButton_pageButton__gfHR2","pageButtonDetails":"PageButton_pageButtonDetails__ETKnx"};